<div class="content">

    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon class="card-header-icon" mat-card-avatar>builds</mat-icon>
            <mat-card-title>Pipelines</mat-card-title>
            <mat-card-subtitle>List of data transformer pipelines</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions style="margin-left: 0px; margin-bottom: 10px;">
            <!-- <button mat-flat-button color="primary" routerLink="/dataTransformConfig/ingest">New Config</button> -->
            <button mat-flat-button style="margin-bottom: 10px;" color="primary" title="Add New Pipeline" [matMenuTriggerFor]="menu">
                <mat-icon>note_add</mat-icon>
                <span style="margin-left: 10px;">New Pipeline</span>
            </button>
            <mat-menu #menu="matMenu" yPosition="below">
                <button mat-menu-item [routerLink]="['/dataTransformConfig', null, 'configDetail']" [state]="{newConfigDataSourceType: 3}">
                    <mat-icon>settings_accessibility</mat-icon>
                    <span>Behavior Data</span>
                </button>
                <button mat-menu-item [routerLink]="['/dataTransformConfig', null, 'configDetail']" [state]="{newConfigDataSourceType: 2}">
                    <mat-icon>assignment_turned_in</mat-icon>
                    <span>Case Data</span>
                </button>
                <button mat-menu-item [routerLink]="['/dataTransformConfig', null, 'configDetail']" [state]="{newConfigDataSourceType: 0}">
                    <mat-icon>access_time</mat-icon>
                    <span>Timestamped Data</span>
                </button>
                <button mat-menu-item [routerLink]="['/dataTransformConfig', null, 'configDetail']" [state]="{newConfigDataSourceType: 1}">
                    <mat-icon>account_circle</mat-icon>
                    <span>User Data</span>
                </button>
            </mat-menu>
        </mat-card-actions>
        <mat-card-content>
            <h1 *ngIf="!hasConfigs || hasError" class="center" style="color: lightgray">{{ hasError ? 'Failed to Load Pipelines' : 'No Pipelines Found' }}</h1>
                                                        
            <table *ngIf="hasConfigs" mat-table [dataSource]="mappingConfigs" class="mat-elevation-z8">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> Id </th>
                    <td mat-cell *matCellDef="let config"> {{config.id}} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let config"> {{config.name}} </td>
                </ng-container>
]
                <ng-container matColumnDef="dataSourceType">
                    <th mat-header-cell *matHeaderCellDef> Type </th>
                    <td mat-cell *matCellDef="let config"> {{DataSourceTypeUtil.toString(config.dataSourceType)}} </td>
                </ng-container>
                
                <ng-container matColumnDef="createdDateTime">
                    <th mat-header-cell *matHeaderCellDef> Created Date </th>
                    <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.createdDateTime, 'MM/dd/yyyy h:mm:ss a')}} </td>
                </ng-container>
                
                <ng-container matColumnDef="modifiedDateTime">
                    <th mat-header-cell *matHeaderCellDef> Modified Date </th>
                    <td mat-cell *matCellDef="let config"> {{datePipe.transform(config.modifiedDateTime, 'MM/dd/yyyy h:mm:ss a')}} </td>
                </ng-container>
                
                <ng-container matColumnDef="modifiedByUser">
                    <th mat-header-cell *matHeaderCellDef> Modified By </th>
                    <td mat-cell *matCellDef="let config"> {{config.modifiedByUserId}} </td>
                </ng-container>
                
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let config">
                        <button mat-icon-button (click)="$event.stopPropagation(); duplicateConfig(config)">
                            <mat-icon color="primary" class="icon" matTooltip="Duplicate Pipeline">content_copy</mat-icon>
                        </button>
                        <button mat-icon-button (click)="$event.stopPropagation(); deleteConfig(config)">
                            <mat-icon class="red-icon" matTooltip="Delete Pipeline">delete_forever</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row style="cursor: pointer;" 
                    *matRowDef="let config; columns: displayedColumns;" 
                    (click)="loadConfigDetail(config)"></tr>
            </table>
        </mat-card-content>
        <!-- <mat-card-actions align="end">
            <button mat-button>ADD NEW TASK</button>
        </mat-card-actions> -->
    </mat-card>

</div>